import { ref } from 'vue'
import xbb from '@xbb/xbb-utils'
import {
  getWorkProgressList,
  getReviewMsg,
  getFindMsg,
  getFollowMsg,
  getTrainingMsg,
  hasRead
} from '@/api/app-home.js'

export function useHomePageData() {
  const hasAnalyst = ref(0)
  const hasFindCustomer = ref(0)
  const appKey = ref('')
  const messageList = ref([])
  const analystList = ref([])
  const findList = ref([])
  const followList = ref([])
  const trainingList = ref([])

  const addViewStatus = (list, isView) => {
    return list.map((item) => {
      return {
        ...item,
        isView
      }
    })
  }

  const getBroadcast = async () => {
    try {
      const res = await getWorkProgressList()
      console.log('res: ', res)
      messageList.value = xbb._get(res, 'result.messageList', [])
    } catch (error) {
      console.error('getWorkProgressList error: ', error)
    }
  }

  const getReview = async () => {
    try {
      const res = await getReviewMsg()
      analystList.value = xbb._get(res, 'result.msgList', [])
      hasAnalyst.value = xbb._get(res, 'result.isView', 0)
    } catch (error) {
      console.error('getReviewMsg error: ', error)
    }
  }

  const getFind = async () => {
    try {
      const res = await getFindMsg()
      findList.value = xbb._get(res, 'result.msgList', [])
      appKey.value = xbb._get(res, 'result.appKey', '')
      hasFindCustomer.value = xbb._get(res, 'result.isView', 0)
    } catch (error) {
      console.error('getFindMsg error: ', error)
    }
  }

  const getFollow = async () => {
    try {
      const res = await getFollowMsg()
      followList.value = addViewStatus(xbb._get(res, 'result.followMsgList', []), res.result.isView)
    } catch (error) {
      console.error('getFollowMsg error: ', error)
    }
  }

  const getTraining = async () => {
    try {
      const res = await getTrainingMsg()
      trainingList.value = addViewStatus(
        xbb._get(res, 'result.trainingList', []),
        res.result.isView
      )
    } catch (error) {
      console.error('getTrainingMsg error: ', error)
    }
  }

  const handleRead = async (data) => {
    try {
      await hasRead(data)
      if (data.refType === 1) {
        await getReview()
      } else if (data.refType === 2) {
        await getFind()
      } else if (data.refType === 3) {
        await getTraining()
      } else if (data.refType === 4) {
        await getFollow()
      }
    } catch (error) {
      console.error('handleRead error: ', error)
    }
  }

  const initHomeData = async () => {
    await Promise.all([getBroadcast(), getReview(), getFind(), getFollow(), getTraining()])
  }

  return {
    hasAnalyst,
    hasFindCustomer,
    appKey,
    messageList,
    analystList,
    findList,
    followList,
    trainingList,
    getBroadcast,
    getReview,
    getFind,
    getFollow,
    getTraining,
    handleRead,
    initHomeData
  }
}
